<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.cirurgiasInternacoes"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {key: 'descricao', label: 'Descrição', sortable: true},
            {key: 'realizadaEm.data', label: 'Realizada em', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o antecedente hospitalar?', async () => {
                this.data.model.cirurgiasInternacoes.splice(index, 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>